<div class="divisa-list divisa-row">
  <img class="divisa-list-image" [src]="divisa.currency.logoUrl" alt="" />
  <span class="divisa-name m-2 divisa-col-1">{{ divisa.currency.code }}</span>
  <span class="divisa-fullname d-none d-lg-block divisa-col">{{
    divisa.currency.code | currencyName : divisa.currency.name
  }}</span>
  <div class="fecha-tipo-cambio d-none d-lg-block divisa-col">
    <span class="divisa-list-fecha divisa-row">{{
      "SHARED.RATE_AS_OF" | translate
    }}</span>
    <span class="divisa-list-fecha-var divisa-row">{{
      divisa.updateAt | date: "dd/MM/yyyy"
    }}</span>
  </div>
  <div class="moneda-tipo-cambio divisa-col">
    <span class="divisa-list-moneda"
      >{{ "LANDING.PRICE_TABLE.COLUMN_BUY" | translate }}
    </span>
    <div>
      <span class="divisa-list-moneda-var"
        >{{ divisa.buy | mxnCurrency }}
      </span>
    </div>
  </div>
  <div class="moneda-tipo-cambio divisa-col">
    <span class="divisa-list-moneda"
      >{{ "LANDING.PRICE_TABLE.COLUMN_SELL" | translate }}
    </span>
    <div>
      <span class="divisa-list-moneda-var"
        >{{ divisa.sell | mxnCurrency }}
      </span>
    </div>
  </div>
  <button
    mat-raised-button
    color="accent"
    [attr.aria-label]="'HOME_BRANCHES.RESERVE_BUTTON' | translate"
    class="d-none d-lg-block button"
    (click)="openDialog()"
  >
    {{ "HOME_BRANCHES.RESERVE_BUTTON" | translate }}
    <mat-icon iconPositionEnd svgIcon="payments"></mat-icon>
  </button>
  <button
    mat-mini-fab
    color="accent"
    [attr.aria-label]="'HOME_BRANCHES.RESERVE_BUTTON' | translate"
    class="d-lg-none d-block icon-sm-button"
    (click)="openDialog()"
  >
    <mat-icon class="mt-1" svgIcon="payments"></mat-icon>
  </button>
</div>
